export type FixturePuzzle = {
  prompt: string;
  glyph: string;
  fixtureIndex: number;
};

export function isFixturePuzzle(value: unknown): value is FixturePuzzle {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<FixturePuzzle>;
  return (
    typeof candidate.prompt === 'string' &&
    typeof candidate.glyph === 'string' &&
    typeof candidate.fixtureIndex === 'number'
  );
}
